import { APP_IMG } from 'src/constants';

export const IMAGE_SIZE = {
  XS: 'xs',
  XS_WEBP: 'xs-webp',
  MD: 'md',
  MD_WEBP: 'md-webp',
  LG: 'lg',
  LG_WEBP: 'lg-webp',
  XL: 'XL',
  XL_WEBP: 'xl-webp',
  XXL: 'XXL',
  XXL_WEBP: 'xxl-webp'
};

const Image = ({
  src = '',
  alt,
  title,
  external = false,
  size,
  externalLink = '',
  className = '',
  width,
  height,
  loading = 'lazy',
  decoding = 'async',
  fetchPriority
}) => {
  const imgUrl = external ? (externalLink ? `${externalLink}${src}` : `${src}`) : `${APP_IMG}${src}`;
  const source = `${imgUrl}?x-image-process=style/${size || 'lg-webp'}`;
  const altText = alt ?? title;
  const images = (
    // display:block + width:100% so the img has a width to resolve against → its CSS aspect-ratio
    // can reserve space BEFORE the image loads (an inline <picture> collapses to 0 and causes CLS).
    <picture className='resolution-image' style={{ display: 'block', width: '100%' }}>
      {!size && <source srcSet={`${imgUrl}?x-image-process=style/xs-webp`} media={'(max-width: 450px)'} type='image/webp' />}
      <source srcSet={`${imgUrl}?x-image-process=style/md-webp`} media={'(max-width: 690px)'} type='image/webp' />
      <source srcSet={source} media={'(min-width: 691px)'} type='image/webp' />
      <img
        className={className}
        src={source}
        title={altText || 'image'}
        alt={altText}
        width={width}
        height={height}
        loading={loading}
        decoding={decoding}
        fetchPriority={fetchPriority}
      />
    </picture>
  );

  return <div className='lazyload-wrapper' style={{ width: '100%' }}>{images}</div>;
};

export default Image;
